export const DEPARTMENT_STRUCTURE = {
  'CEO Office': {
    name: 'CEO Office',
    head: 'Mr. Tom',
    headEmail: 'tom@gratoengineering.com',
    positions: {}
  },

  'Technical': {
    name: 'Technical',
    head: 'Mr. Didier Oyong',
    headEmail: 'didier.oyong@gratoengineering.com',
    positions: {
      'HSE Coordinator': {
        name: 'Mr. Ovo Bechem',
        email: 'bechem.mbu@gratoglobal.com',
        supervisor: 'Technical Director',
        department: 'Technical'
      },
      'Head of Refurbishment': {
        name: 'Mr. Verla Ivo',
        email: 'verla.ivo@gratoengineering.com',
        supervisor: 'Technical Director',
        department: 'Technical'
      },
      'Project Manager': {
        name: 'Mr. Joel Wamba',
        email: 'joel@gratoengineering.com',
        supervisor: 'Technical Director',
        department: 'Technical'
      },
      'Operations Manager': {
        name: 'Mr. Pascal Assam',
        email: 'pascal.rodrique@gratoglobal.com',
        supervisor: 'Technical Director',
        department: 'Technical'
      },
      'Diesel Coordinator': {
        name: 'Mr. Kevin Minka',
        email: 'minka.kevin@gratoglobal.com',
        supervisor: 'Technical Director',
        department: 'Technical'
      },
      'Data Collector': {
        name: 'Mr. Bemba Essack',
        email: 'bemba.essack@gratoglobal.com',
        supervisor: 'Operations Manager',
        department: 'Technical'
      },
      'NOC Coordinator': {
        name: 'Mr. Rodrigue Nono',
        email: 'rodrigue.nono@gratoglobal.com',
        supervisor: 'Operations Manager',
        department: 'Technical'
      },
      'Site Supervisor - Joseph': {
        name: 'Mr. Joseph TAYOU',
        email: 'joseph.tayou@gratoglobal.com',
        supervisor: 'Operations Manager',
        department: 'Technical'
      },
      'Site Supervisor - Felix': {
        name: 'Mr. Felix Tientcheu',
        email: 'felix.tientcheu@gratoglobal.com',
        supervisor: 'Operations Manager',
        department: 'Technical'
      },
      'NOC Operator - Ervine': {
        name: 'Mr. Ervine Mbezele',
        email: 'ervine.mbezele@gratoglobal.com',
        supervisor: 'NOC Coordinator',
        department: 'Technical'
      },
      'NOC Operator - Yves': {
        name: 'Mr. Yves Yossa',
        email: 'yossa.yves@gratoglobal.com',
        supervisor: 'NOC Coordinator',
        department: 'Technical'
      },
      'NOC Operator - Wilfried': {
        name: 'Mr. Wilfried Kamegni',
        email: 'kamegni.wilfried@gratoglobal.com',
        supervisor: 'NOC Coordinator',
        department: 'Technical'
      },
      'NOC Operator - Junior': {
        name: 'Mr. Junior Mukudi',
        email: 'junior.mukudi@gratoglobal.com',
        supervisor: 'NOC Coordinator',
        department: 'Technical'
      },
      'Field Technician - Boris': {
        name: 'Mr. Boris Kamgang',
        email: 'kamgang.junior@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Sunday': {
        name: 'Mr. Sunday',
        email: 'sunday@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Ulrich': {
        name: 'Mr. Ulrich MOUMI',
        email: 'ulrich.vitrand@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Abeeb': {
        name: 'Mr. Abeeb',
        email: 'abeeb@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Paul': {
        name: 'Mr. Paul EM Nyomb',
        email: 'paul.nyomb@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Edidie': {
        name: 'Mr. EDIDIE François',
        email: 'edidie.francois@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Berthin': {
        name: 'Mr. Berthin DEFFO',
        email: 'mba.berthin@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Allassane': {
        name: 'Mr. Allassane',
        email: 'allassane@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Alioum': {
        name: 'Mr. Alioum Moussa',
        email: 'alioum.moussa@gratoglobal.com',
        supervisor: 'Site Supervisor - Joseph',
        department: 'Technical'
      },
      'Field Technician - Kenfack': {
        name: 'Mr. Kenfack Jacques',
        email: 'kenfack.jacques@gratoglobal.com',
        supervisor: 'Site Supervisor - Felix',
        department: 'Technical'
      },
      'Field Technician - Djackba': {
        name: 'Mr. Djackba Marcel',
        email: 'djackba.marcel@gratoglobal.com',
        supervisor: 'Site Supervisor - Felix',
        department: 'Technical'
      },
      'Field Technician - Danick': {
        name: 'Mr. Danick Djiyap',
        email: 'djiyap.danick@gratoglobal.com',
        supervisor: 'Site Supervisor - Felix',
        department: 'Technical'
      }
    }
  },

  'Business Development & Supply Chain': {
    name: 'Business Development & Supply Chain',
    head: 'Mr. E.T Kelvin',
    headEmail: 'kelvin.eyong@gratoglobal.com',
    positions: {
      'Supply Chain Coordinator': {
        name: 'Mr. Lukong Lambert',
        email: 'lukong.lambert@gratoglobal.com',
        supervisor: 'Head of Business Dev & Supply Chain',
        department: 'Business Development & Supply Chain'
      },
      'Order Management Assistant': {
        name: 'Ms. Christabel Mangwi',
        email: 'christabel@gratoengineering.com',
        supervisor: 'Head of Business Dev & Supply Chain',
        department: 'Business Development & Supply Chain'
      },
      'Warehouse Coordinator': {
        name: 'Mr. Pryde Mua',
        email: 'pryde.mua@gratoglobal.com',
        supervisor: 'Supply Chain Coordinator',
        department: 'Business Development & Supply Chain'
      },
      'Warehouse Assistant': {
        name: 'Ms. Aghangu Marie',
        email: 'marie.shurinani@gratoglobal.com',
        supervisor: 'Warehouse Coordinator',
        department: 'Business Development & Supply Chain'
      },
      'Finance Officer': {
        name: 'Ms. Ranibell Mambo',
        email: 'ranibellmambo@gratoengineering.com',
        supervisor: 'Head of Business Dev & Supply Chain',
        department: 'Business Development & Supply Chain'
      }
    }
  },

  'HR & Admin': {
    name: 'HR & Admin',
    head: 'Mrs. Bruiline Tsitoh',
    headEmail: 'bruiline.tsitoh@gratoglobal.com',
    positions: {
      'Office Driver/Logistics Assistant': {
        name: 'Mr. Che Earnest',
        email: 'che.earnest@gratoengineering.com',
        supervisor: 'HR & Admin Head',
        department: 'HR & Admin'
      },
      'House Maid': {
        name: 'Ms. Ndi Belther',
        email: 'ndi.belther@gratoengineering.com',
        supervisor: 'HR & Admin Head',
        department: 'HR & Admin'
      },
      'HR Assistant': {
        name: 'Ms. Carmel Dafny',
        email: 'carmel.dafny@gratoglobal.com',
        supervisor: 'HR & Admin Head',
        department: 'HR & Admin'
      },
      'Receptionist': {
        name: 'Ms. Esther Lum',
        email: 'esther.lum@gratoglobal.com',
        supervisor: 'HR & Admin Head',
        department: 'HR & Admin'
      }
    }
  },

  'IT': {
    name: 'IT',
    head: 'Mr. E.T Kelvin',
    headEmail: 'kelvin.eyong@gratoglobal.com',
    positions: {
      'IT Staff': {
        name: 'Marcel Ngong',
        email: 'marcel.ngong@gratoglobal.com',
        supervisor: 'Head of Business Dev & Supply Chain',
        department: 'IT'
      }
    }
  }
};

// Role mapping based on organizational structure
export const ROLE_MAPPING = {
  // Executive Level
  'Mr. Tom': 'ceo',
  
  // Department Heads (admin level)
  'Mr. Didier Oyong': 'admin',
  'Mr. E.T Kelvin': 'admin', 
  'Mrs. Bruiline Tsitoh': 'admin',
  
  // Senior Management (supervisor level)
  'Mr. Ovo Bechem': 'supervisor',
  'Mr. Verla Ivo': 'supervisor',
  'Mr. Joel Wamba': 'supervisor',
  'Mr. Pascal Assam': 'supervisor',
  'Mr. Kevin Minka': 'supervisor',
  'Mr. Lukong Lambert': 'supervisor',
  'Mr. Pryde Mua': 'supervisor',
  
  // Finance specific
  'Ms. Ranibell Mambo': 'finance',
  
  // IT specific  
  'Marcel Ngong': 'it',
  
  // Coordinators and mid-level (supervisor)
  'Mr. Rodrigue Nono': 'supervisor',
  'Mr. Joseph TAYOU': 'supervisor',
  'Mr. Felix Tientcheu': 'supervisor',
  
  // Staff level (employee)
  'Mr. Bemba Essack': 'employee',
  'Ms. Christabel Mangwi': 'employee',
  'Ms. Aghangu Marie': 'employee',
  'Mr. Che Earnest': 'employee',
  'Ms. Ndi Belther': 'employee',
  'Ms. Carmel Dafny': 'employee',
  'Ms. Esther Lum': 'employee',
  'Mr. Ervine Mbezele': 'employee',
  'Mr. Yves Yossa': 'employee',
  'Mr. Wilfried Kamegni': 'employee',
  'Mr. Junior Mukudi': 'employee',
  'Mr. Boris Kamgang': 'employee',
  'Mr. Sunday': 'employee',
  'Mr. Ulrich MOUMI': 'employee',
  'Mr. Abeeb': 'employee',
  'Mr. Paul EM Nyomb': 'employee',
  'Mr. EDIDIE François': 'employee',
  'Mr. Berthin DEFFO': 'employee',
  'Mr. Allassane': 'employee',
  'Mr. Alioum Moussa': 'employee',
  'Mr. Kenfack Jacques': 'employee',
  'Mr. Djackba Marcel': 'employee',
  'Mr. Danick Djiyap': 'employee'
};

// Department role mapping for role assignment
export const DEPARTMENT_ROLE_MAPPING = {
  'CEO Office': {
    'Mr. Tom': 'head'
  },
  'Technical': {
    'Mr. Didier Oyong': 'head',
    'Mr. Ovo Bechem': 'coordinator',
    'Mr. Verla Ivo': 'supervisor',
    'Mr. Joel Wamba': 'supervisor',
    'Mr. Pascal Assam': 'supervisor',
    'Mr. Kevin Minka': 'coordinator',
    'Mr. Rodrigue Nono': 'coordinator',
    'Mr. Joseph TAYOU': 'supervisor',
    'Mr. Felix Tientcheu': 'supervisor',
    'Mr. Bemba Essack': 'staff',
    'Mr. Ervine Mbezele': 'staff',
    'Mr. Yves Yossa': 'staff',
    'Mr. Wilfried Kamegni': 'staff',
    'Mr. Junior Mukudi': 'staff',
    'Mr. Boris Kamgang': 'staff',
    'Mr. Sunday': 'staff',
    'Mr. Ulrich MOUMI': 'staff',
    'Mr. Abeeb': 'staff',
    'Mr. Paul EM Nyomb': 'staff',
    'Mr. EDIDIE François': 'staff',
    'Mr. Berthin DEFFO': 'staff',
    'Mr. Allassane': 'staff',
    'Mr. Alioum Moussa': 'staff',
    'Mr. Kenfack Jacques': 'staff',
    'Mr. Djackba Marcel': 'staff',
    'Mr. Danick Djiyap': 'staff'
  },
  'Business Development & Supply Chain': {
    'Mr. E.T Kelvin': 'head',
    'Mr. Lukong Lambert': 'coordinator',
    'Mr. Pryde Mua': 'coordinator',
    'Ms. Ranibell Mambo': 'staff',
    'Ms. Christabel Mangwi': 'staff',
    'Ms. Aghangu Marie': 'staff'
  },
  'HR & Admin': {
    'Mrs. Bruiline Tsitoh': 'head',
    'Mr. Che Earnest': 'staff',
    'Ms. Ndi Belther': 'staff',
    'Ms. Carmel Dafny': 'staff',
    'Ms. Esther Lum': 'staff'
  },
  'IT': {
    'Marcel Ngong': 'staff'
  }
};

// Helper functions
export const getDepartmentList = () => {
  return Object.keys(DEPARTMENT_STRUCTURE)
    .filter(key => key !== 'CEO Office')
    .map(key => ({
      key,
      name: DEPARTMENT_STRUCTURE[key].name,
      head: DEPARTMENT_STRUCTURE[key].head,
      headEmail: DEPARTMENT_STRUCTURE[key].headEmail
    }));
};

export const getEmployeesInDepartment = (department) => {
  const dept = DEPARTMENT_STRUCTURE[department];
  if (!dept) return [];

  const employees = [];

  // Add department head if not CEO Office
  if (department !== 'CEO Office') {
    employees.push({
      name: dept.head,
      email: dept.headEmail,
      position: 'Department Head',
      department: department,
      supervisor: department === 'IT' ? 'Head of Business Dev & Supply Chain' : 'President',
      role: ROLE_MAPPING[dept.head] || 'admin',
      departmentRole: 'head'
    });
  }

  // Add other positions
  for (const [position, data] of Object.entries(dept.positions || {})) {
    employees.push({
      name: data.name,
      email: data.email,
      position: position,
      department: department,
      supervisor: data.supervisor,
      role: ROLE_MAPPING[data.name] || 'employee',
      departmentRole: DEPARTMENT_ROLE_MAPPING[department]?.[data.name] || 'staff'
    });
  }

  return employees;
};

export const getAllEmployees = () => {
  const allEmployees = [];
  
  Object.keys(DEPARTMENT_STRUCTURE).forEach(department => {
    const employees = getEmployeesInDepartment(department);
    allEmployees.push(...employees);
  });
  
  return allEmployees;
};

export const getApprovalChain = (employeeName, department) => {
  const chain = [];

  console.log(`Getting approval chain for: ${employeeName} in ${department}`);

  // Find the employee's data
  let employeeData = null;
  let employeeDepartmentName = department;

  // Search for employee in specified department first
  if (DEPARTMENT_STRUCTURE[department]) {
    if (DEPARTMENT_STRUCTURE[department].head === employeeName) {
      employeeData = {
        name: employeeName,
        email: DEPARTMENT_STRUCTURE[department].headEmail,
        position: 'Department Head',
        supervisor: department === 'IT' ? 'Head of Business Dev & Supply Chain' : 'President',
        department: department
      };
    } else {
      for (const [pos, data] of Object.entries(DEPARTMENT_STRUCTURE[department].positions || {})) {
        if (data.name === employeeName) {
          employeeData = { ...data, position: pos };
          break;
        }
      }
    }
  }

  // If not found, search all departments
  if (!employeeData) {
    for (const [deptKey, deptData] of Object.entries(DEPARTMENT_STRUCTURE)) {
      if (deptData.head === employeeName) {
        employeeData = {
          name: employeeName,
          email: deptData.headEmail,
          position: 'Department Head',
          supervisor: deptKey === 'IT' ? 'Head of Business Dev & Supply Chain' : 'President',
          department: deptKey
        };
        employeeDepartmentName = deptKey;
        break;
      }
      
      if (deptData.positions) {
        for (const [pos, data] of Object.entries(deptData.positions)) {
          if (data.name === employeeName) {
            employeeData = { ...data, position: pos };
            employeeDepartmentName = deptKey;
            break;
          }
        }
      }
      
      if (employeeData) break;
    }
  }

  // If still not found, create default chain
  if (!employeeData) {
    console.warn(`Employee "${employeeName}" not found. Creating default approval chain.`);
    
    if (DEPARTMENT_STRUCTURE[department]) {
      chain.push({
        level: 1,
        approver: DEPARTMENT_STRUCTURE[department].head,
        email: DEPARTMENT_STRUCTURE[department].headEmail,
        role: 'Department Head',
        department: department
      });
    }
    
    if (DEPARTMENT_STRUCTURE['Business Development & Supply Chain']) {
      chain.push({
        level: chain.length + 1,
        approver: DEPARTMENT_STRUCTURE['Business Development & Supply Chain'].head,
        email: DEPARTMENT_STRUCTURE['Business Development & Supply Chain'].headEmail,
        role: 'President',
        department: 'Business Development & Supply Chain'
      });
    }
    
    return chain;
  }

  let currentEmployee = employeeData;
  let currentDepartment = employeeDepartmentName;
  let level = 1;

  // Traverse up the approval chain
  while (currentEmployee && currentEmployee.supervisor) {
    let supervisorFound = false;

    // Check positions in current department
    if (DEPARTMENT_STRUCTURE[currentDepartment]?.positions) {
      for (const [pos, data] of Object.entries(DEPARTMENT_STRUCTURE[currentDepartment].positions)) {
        if (pos === currentEmployee.supervisor || data.name === currentEmployee.supervisor) {
          chain.push({
            level: level++,
            approver: data.name,
            email: data.email,
            role: pos,
            department: currentDepartment
          });
          currentEmployee = { ...data, position: pos };
          supervisorFound = true;
          break;
        }
      }
    }

    // Check if supervisor is department head
    if (!supervisorFound && DEPARTMENT_STRUCTURE[currentDepartment] && 
        (DEPARTMENT_STRUCTURE[currentDepartment].head === currentEmployee.supervisor || 
         currentEmployee.supervisor.includes('Head') || 
         currentEmployee.supervisor.includes('Director'))) {
      
      chain.push({
        level: level++,
        approver: DEPARTMENT_STRUCTURE[currentDepartment].head,
        email: DEPARTMENT_STRUCTURE[currentDepartment].headEmail,
        role: 'Department Head',
        department: currentDepartment
      });
      
      currentEmployee = {
        name: DEPARTMENT_STRUCTURE[currentDepartment].head,
        supervisor: currentDepartment === 'IT' ? 'Head of Business Dev & Supply Chain' : 'President',
        department: currentDepartment
      };
      supervisorFound = true;
    }

    // Check if supervisor is President or Head of Business
    if (!supervisorFound && (currentEmployee.supervisor === 'President' || currentEmployee.supervisor === 'Head of Business Dev & Supply Chain')) {
      if (DEPARTMENT_STRUCTURE['Business Development & Supply Chain']) {
        chain.push({
          level: level++,
          approver: DEPARTMENT_STRUCTURE['Business Development & Supply Chain'].head,
          email: DEPARTMENT_STRUCTURE['Business Development & Supply Chain'].headEmail,
          role: 'President',
          department: 'Business Development & Supply Chain'
        });
      }
      currentEmployee = null;
      supervisorFound = true;
    }

    if (!supervisorFound) {
      console.warn(`Supervisor "${currentEmployee.supervisor}" not found. Adding fallback approvers.`);
      
      // Add department head if not already in chain
      if (DEPARTMENT_STRUCTURE[currentDepartment] && !chain.some(step => step.role === 'Department Head')) {
        chain.push({
          level: level++,
          approver: DEPARTMENT_STRUCTURE[currentDepartment].head,
          email: DEPARTMENT_STRUCTURE[currentDepartment].headEmail,
          role: 'Department Head',
          department: currentDepartment
        });
      }
      
      // Add president if not already in chain
      if (DEPARTMENT_STRUCTURE['Business Development & Supply Chain'] && !chain.some(step => step.role === 'President')) {
        chain.push({
          level: level++,
          approver: DEPARTMENT_STRUCTURE['Business Development & Supply Chain'].head,
          email: DEPARTMENT_STRUCTURE['Business Development & Supply Chain'].headEmail,
          role: 'President',
          department: 'Business Development & Supply Chain'
        });
      }
      
      break;
    }
  }

  return chain;
};

export const getUserHierarchyLevel = (name, department) => {
  if (name === 'Mr. Tom') return 6; 
  if (name === 'Mr. E.T Kelvin') return 5;
  
  const dept = DEPARTMENT_STRUCTURE[department];
  if (!dept) return 1;
  
  if (dept.head === name) return 4; 
  
  // Check positions for hierarchy levels
  for (const [position, data] of Object.entries(dept.positions || {})) {
    if (data.name === name) {
      if (position.includes('Head') || position.includes('Director')) return 4;
      if (position.includes('Manager') || position.includes('Coordinator')) return 3;
      if (position.includes('Supervisor')) return 2;
      return 1; 
    }
  }
  
  return 1;
};